import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import partial from 'lodash/partial';
import idx from 'idx';
import {
  toggleAddParticipantsModal, addParticipantRequest, fetchParticipants
} from 'presentations/ducks';
import { ADD_PARTICIPANTS_FORM_NAME } from 'presentations/constants';
import AddParticipantsModal from 'presentations/components/add_participants_modal';

const mapStateToProps = (state) => {
  const { showingAddParticipantsModal, currentPresentation } = state.project.presentations;
  const weightVotes = currentPresentation.weight_votes;
  const { profile_data } = state.user;
  const initialValues = {
    participants: [],
    first_name: idx(profile_data, _ => _.first_name),
    last_name: idx(profile_data, _ => _.last_name),
  };

  return {
    showing: showingAddParticipantsModal,
    weightVotes,
    initialValues,
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const { presentationId } = params;

  return bindActionCreators({
    toggle: toggleAddParticipantsModal,
    fetch: partial(fetchParticipants, presentationId),
    addRequest: partial(addParticipantRequest, presentationId),
  }, dispatch);
}

const validate = (values) => {
  const errors = {};
  if (!values.participants || values.participants.length == 0) {
    errors.participants = { _error: 'You must add at least one participant' };
  }
  return errors;
}

const Form = reduxForm({
  form: ADD_PARTICIPANTS_FORM_NAME,
  validate
})(AddParticipantsModal);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./presentations/containers/add_participants_modal.js